import { render } from "./CDropdown.vue?vue&type=template&id=1971a9fa&scoped=true"
import script from "./CDropdown.vue?vue&type=script&lang=js"
export * from "./CDropdown.vue?vue&type=script&lang=js"

import "./CDropdown.vue?vue&type=style&index=0&id=1971a9fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1971a9fa"]])

export default __exports__